var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._b({}, 'v-btn', Object.assign({}, _vm.defaultBtnProps, _vm.btnProps), false), [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-phone")]), _vm._v(" (631) 581-9200 ")], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }